import BackgroundImageComponent from '@components/common/background-image'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { SKILLS_YOU_WILL_GAIN } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'
import { Check } from 'react-feather'

type Props = {
  courseName: CourseNameType
  urlQuery?: string
}
const SkillsYouWillGain = ({ courseName, urlQuery }: Props) => {
  const coursesData = SKILLS_YOU_WILL_GAIN[courseName]

  return (
    <div className="mb-10 lg:px-3 py-5 flex flex-col text-grey">
      {coursesData.title && (
        <h2 className="text-2xl font-600 leading-tight">
          {coursesData.title}{' '}
        </h2>
      )}
      {coursesData.description && (
        <p className="lg:text-lg mt-4">{coursesData.description}</p>
      )}

      <div className="my-8 overflow-hidden relative py-5 md:px-5 lg:items-start">
        <BackgroundImageComponent
          image="/images/courses/skills-bg.png"
          top={0}
          left={0}
        />
        <div className="relative px-2 lg:px-16 pt-4">
          <h3 className="text-2xl font-600">Skills you’ll gain</h3>
          <div className="space-y-2 text-grey mt-5">
            {coursesData.skills.map((skills) => (
              <div key={skills} className="flex items-start">
                <span
                  className="rounded-full text-orange-700"
                  style={{
                    padding: '1px',
                    margin: '6px 0 0 0',
                    background: '#FFEBE9',
                    color: '#FF5A43',
                  }}
                >
                  <Check height={10} width={10} strokeWidth={4} />
                </span>
                <p className="ml-1 text-left">{skills}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mx-auto w-full md:max-w-xs text-center">
        <BookFreeClassBtn query={urlQuery} />
      </div>
    </div>
  )
}

export default SkillsYouWillGain
